import React, { useState } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { AuthContext } from "./context/auth";

import Home from "./pages/Home";
import Centro from "./pages/Centro";
import Empresas from "./pages/Empresas";
import Faq from "./pages/Faq";
import Nosotros from "./pages/Nosotros";

import PaginaPrincipal from "./pages/PaginaPrincipal";
import Acceso from "./pages/Acceso";

import Wrapper from "./layout/Wrapper";
import PrivateRoute from "./PrivateRoute";
import Registrate from "./pages/Registrate";
import ResetPassword from "./pages/ResetPassword";
import UpdatePassword from "./pages/UpdatePassword";
import * as serviceWorker from "./serviceWorker";
import useLogRocket from "./Hooks/useLogRocket";
import {
  RedirectCandidato,
  RedirectCurso,
  RedirectEmpresa,
  RedirectVacante,
} from "./layout/ShareRedirect";
import Manual from "./components/Manual/Manual";
import ManualEmpresa from "./components/Manual/ManualEmpresa";
function App() {
  useLogRocket();

  const existingTokens = JSON.parse(localStorage.getItem("tokens"));
  const [authTokens, setAuthTokens] = useState(existingTokens);

  const setTokens = (data) => {
    localStorage.setItem("tokens", JSON.stringify(data));
    setAuthTokens(data);
  };
  return (
    <AuthContext.Provider value={{ authTokens, setAuthTokens: setTokens }}>
      <BrowserRouter>
        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/Login" exact component={Acceso} />
          <Route path="/Formacion" exact component={Centro} />
          <Route path="/Empresas" exact component={Empresas} />
          <Route path="/Teayudamos" exact component={Faq} />
          <Route path="/Sobrenosotros" exact component={Nosotros} />
          <Route path="/ManualUsuario" exact component={Manual} />
          <Route path="/ManualEmpresa" exact component={ManualEmpresa} />

          <PrivateRoute
            path="/PaginaPrincipal"
            component={PaginaPrincipal}
          ></PrivateRoute>

          <Route path="/compartir">
            <Route
              path="/compartir/candidato/:id"
              component={RedirectCandidato}
            />
            <Route path="/compartir/vacante/:id" component={RedirectVacante} />
            <Route path="/compartir/curso/:id" component={RedirectCurso} />
            <Route path="/compartir/empresa/:id" component={RedirectEmpresa} />
          </Route>
          <Route path="/Registrate" component={Registrate} />
          <Route path="/ResetPassword" component={ResetPassword} />
          <Route path="/UpdatePassword" component={UpdatePassword} />

          <Route path="/user" component={Wrapper} />
          <Route path="/admin" component={Wrapper} />
          <Route path="/modarator" component={Wrapper} />
          <Route path="/company" component={Wrapper} />
          <Route path="/CentroFormacion" component={Wrapper} />
        </Switch>
      </BrowserRouter>
    </AuthContext.Provider>
  );
}

export default App;

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
// Attach root container
